import * as React from 'react';
import { GlobalStyle } from '../Shared/Shared';

const Layout: React.FC<{
  header?: React.ReactNode;
  children?: React.ReactNode;
}> = ({ children, header }) => {
  return (
    <>
      {!!header && <header>{header}</header>}
      <GlobalStyle />
      <div>
        <main>{children}</main>
      </div>
    </>
  );
};

export default Layout;
